import React, { Component } from 'react'
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import IconButton from '@material-ui/core/IconButton'
import DeleteIcon from '@mui/icons-material/Delete'
import TextField from '@material-ui/core/TextField'
import { ISubSensor } from '../../../../model/SubSensor';

interface SubSensorsTableProps
{
  subSensors: ISubSensor[];
  onDelete: (id: string) => void;
  handleTextFieldChange: (rowId: string, columnName: string, value: string) => void
}
interface SensorParameter
{
  id: string;
  name: string;
  parameter: string | number;
  value: string | number;
}

export class SubSensorsTable extends Component<SubSensorsTableProps>
{
  render()
  {

    const { subSensors, onDelete, handleTextFieldChange } = this.props;
    return(
      <TableContainer component={Paper}>
        <Table aria-label="parameters table">
          <TableHead>
            <TableRow>
              <TableCell>Device ID</TableCell>
              <TableCell>Type</TableCell>
              <TableCell>Behaviour</TableCell>
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {subSensors && subSensors.length > 0 && subSensors.map((row) => (
              <TableRow hover key={row.id}>

                <TableCell component="th" scope="row">
                  <TextField onChange={(e) => handleTextFieldChange(row.id, "deviceId", e.target.value)} value={row.deviceId} placeholder="Device ID" />
                </TableCell>

                <TableCell>
                  <TextField onChange={(e) => handleTextFieldChange(row.id, "type", e.target.value)} value={row.type} placeholder="Type"/>
                </TableCell>

                <TableCell>
                  <TextField onChange={(e) => handleTextFieldChange(row.id, "behaviour", e.target.value)} value={row.behaviour} placeholder="Behaviour" />
                </TableCell>

                <TableCell align="center">
                  <IconButton onClick={() => onDelete(row.id)}><DeleteIcon /></IconButton>
                </TableCell>

              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    )
  }
}